if ($('.type-detail').length) {


    $(document).on('UpsellProductRendered', function () {
        if ($('.customCart .up-banner-wrapper').length) {
            $('.p-info-wrapper').append($('.customCart .up-banner-wrapper').clone().addClass('cloned'));
        }
    });

    $('.p-info-wrapper').append('<div class="availTime"></div>');
    $('.availTime').append($('.availability-value'));
    if ($('.shipping-options').length) {
        $('.availTime').append($('.shipping-options'))
    };

    if ($('#relatedFiles').length) {
        $('#relatedFiles li a').each(function () {
            var nameSplit = $(this).text().trim().split('(')
            $(this).html(`
                <span class="title">${nameSplit[0]}</span>
               
            `)
        })
    }
    if ($('.products-related.products-additional').length) {
        $('#p-detail-tabs .shp-tab').first().after(`
            <li class="shp-tab" data-testid="tabadditional" data-width="">
                <a href="#products-additional" class="shp-tab-link"  role="tab" data-toggle="tab" aria-expanded="false">${translation('souvisejiciProdukty')} (${$('.products-related.products-additional .product').length})</a>
            </li>
        `)
        $('#tab-content').append('<div id="products-additional" class="tab-pane fade in" role="tabpanel"></div>');
        $('#products-additional').append($('.products-related.products-additional'));
    }
    if ($('.basic-description>p img').length) {
        $('.basic-description>p img').each(function () {
            $('.p-info-wrapper').append($(this).closest('p'));
        })

    };

    (function ($) {
        'use strict';

        // Konfigurace
        const CONFIG = {
            apiUrl: 'https://php.shopcode.cz/api/mieleVlasek/apiSkupiny2.php',
            tableSelector: '.p-detail-tabs-wrapper .detail-parameters:not(.detail-parameters__gpsr)',
            autoRun: true // Spustit automaticky při načtení stránky
        };
        let tooltipMap = {};
        /**
         * Hlavní funkce pro reorganizaci parametrů
         */
        function reorganizeParameters() {
            const $table = $(CONFIG.tableSelector);

            if ($table.length === 0) {
                console.warn('Tabulka s parametry nebyla nalezena');
                return;
            }



            $table.find('tr').each(function () {

                const $th = $(this).find('th');

                // název parametru bez ?



                const tooltip = $th.find('.show-tooltip').attr('title');
                const rawName = $th.clone()
                    .find('.show-tooltip').remove().end()
                    .text();

                const name = normalizeNameParam(rawName);






                if (name && tooltip) {
                    tooltipMap[name] = tooltip;
                }
                //console.log(tooltip)
            });
            // Získat HTML tabulky
            const $clone = $table.clone();

            // odstranit tooltip spany z HTML co jde do API
            $clone.find('.show-tooltip').remove();

            const html = $clone[0].outerHTML;

            // Zobrazit loading
            $table.before('<div class="params-loading">Načítám skupiny parametrů...</div>');
            $table.hide();

            // AJAX request
            $.ajax({
                url: CONFIG.apiUrl,
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ html: html }),
                dataType: 'json',
                success: function (response) {
                    if (response.success) {
                        renderGroupedParameters(response, $table);
                    } else {
                        showError('Chyba API: ' + response.error);
                        $('.params-loading').remove();
                        $table.show();
                    }
                },
                error: function (xhr, status, error) {
                    console.error('AJAX Error:', error);
                    //showError('Nepodařilo se načíst skupiny parametrů');
                    $('.params-loading').remove();
                    $table.show();
                }
            }).done(function () {
                initTooltips();
            });
        }

        /**
         * Vykreslení parametrů seskupených podle skupin
         */
        function renderGroupedParameters(response, $originalTable) {
            const $container = $('<div class="parameters-grouped"></div>');

            // Seřadit skupiny (nejprve ty s obsahem, bez skupiny na konec)
            const skupinySerazene = Object.keys(response.skupiny).sort((a, b) => {
                if (a === '(bez skupiny)') return 1;
                if (b === '(bez skupiny)') return -1;
                return a.localeCompare(b, 'cs');
            });

            // Vykreslit každou skupinu
            skupinySerazene.forEach(function (skupinaNazev) {
                const parametry = response.skupiny[skupinaNazev];

                if (parametry.length === 0) return;

                const $skupina = createSkupinaElement(skupinaNazev, parametry);
                $container.append($skupina);
            });

            // Přidat nezařazené parametry (pokud existují)
            if (response.nezarazene && response.nezarazene.length > 0) {
                const $nezarazene = createNezarazeneElement(response.nezarazene);
                $container.append($nezarazene);
            }

            // Nahradit původní tabulku
            $('.params-loading').remove();
            $originalTable.replaceWith($container);
        }

        /**
         * Vytvoření HTML pro jednu skupinu parametrů
         */
        function createSkupinaElement(nazev, parametry) {
            const $skupina = $(`
            <div class="param-group">
                <h4 class="param-group-title">
                    <span class="param-group-name">${escapeHtml(nazev)}</span>
                    <span class="param-group-count">(${parametry.length})</span>
                </h4>
                <table class="param-group-table">
                    <tbody></tbody>
                </table>
            </div>
        `);

            const $tbody = $skupina.find('tbody');

            parametry.forEach(function (param) {
                const skryt = param.skryt === 'Ano' ? ' param-hidden' : '';
                const filtr = param.filtrovat_podle === 'Ano' ? ' param-filterable' : '';
                const tooltip = tooltipMap[normalizeNameParam(param.nazev)];
                let labelHtml = `${escapeHtml(param.nazev)}:`;

                if (tooltip) {
                    labelHtml += `
        <span class="show-tooltip question-tooltip" 
              title="" 
              data-original-title="${escapeHtml(tooltip)}">?</span>
    `;
                }
                //console.log(tooltip)
                const $row = $(`
                <tr class="param-row${skryt}${filtr}" data-rowName="${escapeHtml(param.nazev)}">
                    <th>
                        <span class="row-header-label ${tooltip ? 'has-tooltip' : ''}">
                            ${labelHtml}
                        </span>
                    </th>
                    <td>${escapeHtml(param.hodnota)}</td>
                </tr>
            `);

                $tbody.append($row);
            });

            return $skupina;
        }

        /**
         * Vytvoření HTML pro nezařazené parametry
         */
        function createNezarazeneElement(nezarazene) {
            const $skupina = $(`
            <div class="param-group param-group-unassigned">
                <h4 class="param-group-title">
                    <span class="param-group-name">${translation('nezarazeneParam')}</span>
                    <span class="param-group-count">(${nezarazene.length})</span>
                </h4>
                <table class="param-group-table">
                    <tbody></tbody>
                </table>
            </div>
        `);

            const $tbody = $skupina.find('tbody');

            nezarazene.forEach(function (param) {
                const $row = $(`
                <tr class="param-row" data-rowName="${escapeHtml(param.nazev)}">
                    <th>
                        <span class="row-header-label">${escapeHtml(param.nazev)}:</span>
                    </th>
                    <td>${escapeHtml(param.hodnota)}</td>
                </tr>
            `);

                $tbody.append($row);
            });

            return $skupina;
        }

        /**
         * Zobrazení chybové hlášky
         */
        function showError(message) {
            const $error = $(`
            <div class="params-error" style="color: red; padding: 10px; border: 1px solid red; margin: 10px 0;">
                ❌ ${escapeHtml(message)}
            </div>
        `);

            $(CONFIG.tableSelector).before($error);
        }

        /**
         * Escape HTML
         */
        function escapeHtml(text) {
            if (!text) return '';
            const map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;',
                '?': '&#63;'
            };
            return text.replace(/[&<>"']/g, m => map[m]);
        }

        // Automatické spuštění při načtení stránky
        if (CONFIG.autoRun) {
            $(document).ready(function () {
                reorganizeParameters();
            });
        }

        // Export pro manuální použití
        window.MieleParametry = {
            reorganize: reorganizeParameters,
            config: CONFIG
        };

    })(jQuery);

    if ($('.detail-parameters .productEan').length) {
        // console.log($('.detail-parameters .productEan .productEan__value').text().trim())
        $('<div>', {
            class: 'loadbeeTabContent',
            'data-loadbee-apikey': 'UbMJrCJ9rFRLpRxc4gJ7PrwSMmpJP8hx',
            'data-loadbee-gtin': $('.detail-parameters .productEan .productEan__value').text().trim(),
            'data-loadbee-locale': 'cs_CZ'
        }).appendTo('.basic-description');

        $('<script>', {
            src: 'https://cdn.loadbee.com/js/loadbee_integration.js',
            async: true
        }).appendTo('.basic-description');

    };
    if ($('.extended-description').length) {
        $('#p-detail-tabs .shp-tab').first().after(`
            <li class="shp-tab" data-testid="tabextended" data-width="">
                <a href="#extended-description" class="shp-tab-link"  role="tab" data-toggle="tab" aria-expanded="false">Parametry</a>
            </li>
        `)
        $('#tab-content').append('<div id="extended-description" class="tab-pane fade in" role="tabpanel"></div>');
        $('#extended-description').append($('.extended-description'));

    }




    $('.p-image-wrapper').append($('.product-top>div:not(".col-lg-6") .flags'))


    var energetickeFlagySelector = Object.keys(energetickeNarocnosti).map(function (trida) { return '.' + energetickeNarocnosti[trida]; }).join(', ');

    var selectedFlag = $('.p-image-wrapper .flags').find(energetickeFlagySelector).first();

    if (selectedFlag.length) {
        $('.p-info-wrapper').append(
            $('<div class="flagWrapper"></div>').append(selectedFlag)
        );
    }

    $('.p-info-wrapper').append($('.p-detail-inner-header').clone())
    $('.p-info-wrapper').append($('.p-detail-info').clone());
    $('.p-info-wrapper .p-detail-inner-header').append($('.p-info-wrapper .p-detail-info').html());

    $('.p-info-wrapper').append('<div class="customCart"></div>');
    $('.customCart').append($('.p-final-price-wrapper'));
    $('.customCart').append($('.add-to-cart'));
    $('.customCart .p-final-price-wrapper').append(`<span class="customText">${translation('vcetneDph')}</span>`);



    document.addEventListener('dkLabProductComparerLoaded', function () {
        if (!$('.add-to-cart').length) {
            $('.p-final-price-wrapper').attr('style', 'width:100%;align-items: flex-start;').wrapInner('<div style="text-align: right;"></div>');
            $('.customCart').append($('div#dkLabComparerDiv'));
        }
        $('.customCart').append($('.social-buttons-wrapper'));
    });
    $('.p-info-wrapper .p-short-description').after($(`<a class="desc" href="#description">${translation('detailniPopisProduktu')}</a>`))
    // $('.availability-label').prepend($(`<span class="customText">${translation('produktJe')}</span>`));


    $('.btn.btn-lg.btn-conversion').text(translation('pridatDoKosiku'));





    if ($('.p-thumbnails-wrapper').length) {


        var thumbnailsPerDot = 3;
        var $thumbnails = $('.p-thumbnails-wrapper');
        var $bar = $thumbnails.children('ul.bar');
        var thumbnailCount = $thumbnails.find('.p-thumbnail').length;
        var dotCount = Math.ceil(thumbnailCount / thumbnailsPerDot);
        if (!$bar.length) {
            $bar = $('<ul class="bar"></ul>');
            $thumbnails.append($bar);
        }
        $bar.empty();
        for (var i = 0; i < dotCount; i++) {
            $bar.append('<li class="dot"></li>');
        }
        var $dots = $bar.find('.dot');
        var activeIndex = 0;
        var $thumbnailPrev = $('.p-thumbnails-wrapper .thumbnail-prev');
        var $thumbnailNext = $('.p-thumbnails-wrapper .thumbnail-next');

        function updateThumbnailArrowsState() {
            if (!$dots.length) {
                $thumbnailPrev.addClass('disabled');
                $thumbnailNext.addClass('disabled');
                return;
            }

            $thumbnailPrev.toggleClass('disabled', activeIndex === 0);
            $thumbnailNext.toggleClass('disabled', activeIndex >= $dots.length - 1);
        }

        if ($dots.length) {
            $dots.first().addClass('active');
        }
        updateThumbnailArrowsState();

        $thumbnailPrev.off('click.thumbnailDots').on('click.thumbnailDots', function () {
            if (!$dots.length || activeIndex === 0) {
                return;
            }
            activeIndex -= 1;
            $dots.removeClass('active').eq(activeIndex).addClass('active');
            updateThumbnailArrowsState();
        });

        $thumbnailNext.off('click.thumbnailDots').on('click.thumbnailDots', function () {
            if (!$dots.length || activeIndex >= $dots.length - 1) {
                return;
            }
            activeIndex += 1;
            $dots.removeClass('active').eq(activeIndex).addClass('active');
            updateThumbnailArrowsState();
        });
        $('.p-thumbnails-wrapper').append('<div class="arrowWrapper"></div>')
        $('.p-thumbnails-wrapper .arrowWrapper').append($('.thumbnail-prev'));
        $('.p-thumbnails-wrapper .arrowWrapper').append($('.thumbnail-next'));



    }



    // smazat

    //$('.flagWrapper').append(`<a href="/#/" class='infoList'>Informační list produktu</a>`);


}

function normalizeNameParam(str) {
    return str
        .toLowerCase()
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // diakritika pryč
        .replace(/\?/g, '')
        .replace(':', '')
        .replace(/\s+/g, ' ')
        .trim();
}